<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Set up Native Builds in minutes and start building your apps in the cloud'
    "
    [icon]="'@tui.route'"
    [subtitle]="'How it works'"
    [title]="'Get started in 3 simple steps'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >1. Connect your Git repository</span
      >
      <p class="text-pretty text-lg">
        Connect your GitHub, GitLab, Bitbucket, or Azure DevOps repository to
        Capawesome Cloud. We support both cloud and self-hosted instances.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="consoleBaseUrl"
        target="_blank"
        data-umami-event="native-builds-how-it-works-get-started-button"
      >
        Get started
      </a>
    </div>
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >2. Configure your certificates</span
      >
      <p class="text-pretty text-lg">
        Upload your signing certificates, provisioning profiles, and environment
        variables. We handle the rest securely.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="docsUrl"
        target="_blank"
        data-umami-event="native-builds-how-it-works-configure-button"
      >
        Read the docs
      </a>
    </div>
    <div
      class="flex flex-1 flex-col justify-between gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <span class="text-xl font-bold md:text-2xl"
        >3. Start building your app</span
      >
      <p class="text-pretty text-lg">
        Trigger builds from the console, CLI, or automatically via Git webhooks.
        Download artifacts or publish directly to stores.
      </p>
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="docsUrl"
        target="_blank"
        data-umami-event="native-builds-how-it-works-build-button"
      >
        Read the docs
      </a>
    </div>
  </div>
</section>
